module.exports = __webpack_public_path__ + "media/images/taxi-8b61ba0b82d1bb53879a176661f25b091ce146ec2b9efa3d6ea13e92560c5e3b.svg";